<template>
  <modal ref="modal" class="modal__login-comerciante">
    <template v-slot:cuerpo>
      <div class="logo__login-comerciante">
        <img src="img/logo-ingreso-comercio.svg" alt="logo comercio" />
      </div>
      <div class="inputs__login-comerciante">
        <input
          type="email"
          id="email"
          name="email"
          placeholder="MAIL"
          v-model="model.data.email"
          class="comercio-adherido__login-comerciante"
          @keydown="emailInputKeyDown"
        />
        <input
          type="password"
          id="password"
          name="contraseña"
          placeholder="CONTRASEÑA"
          v-model="model.data.password"
          class="password__login-comerciante"
          @keydown="passwordInputKeyDown"
        />
        <button @click="clickLogIn()" class="btn__login-comerciante">
          <span
            v-show="model.loggingIn"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <img v-show="!model.loggingIn" id="cb-logo" src="img/cunia-right.svg" />
          <span v-show="!model.loggingIn">INGRESAR</span>
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import Swal from "sweetalert2";

import Modal from "../../../components/panel/modals/Modal.vue";

export default {
  props: {
    logInWithEmailAndPasswordFunction: Function,
  },
  components: { Modal },
  data() {
    return {
      model: {
        data: {
          email: undefined,
          password: undefined,
        },
        loggingIn: false,
      },
    };
  },
  methods: {
    async clickLogIn() {
      if (this.model.loggingIn) return;

      this.model.loggingIn = true;

      try {
        await this.logInWithEmailAndPasswordFunction(
          this.model.data.email,
          this.model.data.password
        );
      } catch (error) {
        this.showError(error);
      }

      this.model.loggingIn = false;
    },
    show() {
      this.$refs.modal.abrir();
    },
    showError(error) {
      const status = error.response?.status ?? 0;
      Swal.fire({
        icon: "error",
        title: "Problemas",
        text:
          status == 401
            ? "Usuario y/o contraseña incorrectos"
            : "Error inesperado, código de error: " + status,
        keydownListenerCapture: true,
      });
    },

    emailInputKeyDown(event) {
      if(event.keyCode === 13) {
        this.focusPasswordInput()
      }
    },

    passwordInputKeyDown(event) {
      if(event.keyCode === 13) {
        this.clickLogIn()
      }
    },

    focusPasswordInput() {
      const pwdInput = document.getElementById("password")
      pwdInput.focus();
    }
  
  
  },
};
</script>
<style lang="scss">
.modal__login-comerciante {
  .modal-dialog {
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 100vh;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    padding: 0;
    width: 100vw;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -ms-flex-line-pack: center;
        align-content: center;
    .modal-content {
      height: 273px;
      width: 95%;
      border-radius: 10px;
      background: #c4c4c4;
      .modal-header {
        border: none;
        display: none;
      }
      .modal-body {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -webkit-column-gap: 16px;
           -moz-column-gap: 16px;
                column-gap: 16px;
        padding: 20px;
      }
    }
  }
}

@media (min-width: 344px) {
  .modal__login-comerciante {
    .modal-dialog {
      .modal-content {
        width: 332px;
      }
    }
  }
}

@media (min-width: 576px) {
  .modal__login-comerciante {
    .modal-dialog {
      .modal-content {
        height: 273px;
        width: 414px;
        .modal-body {
          padding: 20px 40px 20px 40px;
          -webkit-column-gap: 28px;
             -moz-column-gap: 28px;
                  column-gap: 28px;
          .inputs__login-comerciante {
            .btn__login-comerciante {
              img {
                bottom: 0px;
                position: relative;
              }
            }
          }
        }
      }
    }
  }
}
</style>
